import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Paginate } from 'src/app/models/interfaces/paginate';
import { ApiEntryControlService } from 'src/app/modules/entry-control/api-entry-control.service';
import { Devices } from 'src/app/modules/entry-control/interfaces/devices';
import { Facility } from 'src/app/modules/entry-control/interfaces/facility';
import { RoundsTags } from 'src/app/modules/entry-control/interfaces/rounds_tags';

@Component({
  selector: 'app-list-tags',
  templateUrl: './list-tags.component.html',
  styleUrls: ['./list-tags.component.css']
})
export class ListTagsComponent implements OnInit {
  error: any;
  constructor(
    private api: ApiEntryControlService,
    private modal: NgbModal,
    private toast: ToastrService,
    private router: Router,

  ) { }
  view: number = 1;
  status: any;
  categorys: any;
  facilityes: Facility[];
  idSelected: number = 0;
  ngOnInit(): void {
    this.get();
    this.api.getAllFacility().subscribe(
      (response) => {
        this.facilityes = response.data as Facility[];
      }
    );
  }

  items: RoundsTags[];
  page = 1;
  perpage: number = 0;
  collectionSize = 0;
  totalPage = 0;

  brands: any;
  form = new UntypedFormGroup({
    id: new UntypedFormControl(),
    facility_id: new UntypedFormControl(0),
  });
  delete() {
    this.api.deleteTags(this.form).subscribe(
      (res) => {
        this.toast.success(
          res.msg,
          'Gestión dispositivos'
        );
        this.modal.dismissAll();
        this.get();
      },
      (e) => {
        this.toast.warning(e.error.mistakes, e.error.msg);
      }
    );
  }

  get() {
    this.api.paginateTags(this.page, this.form).subscribe(
      (response) => {
        var data = response.data as Paginate;
        this.items = data.items as RoundsTags[];
        this.page = data.current;
        this.perpage = data.per_page;
        this.collectionSize = data.count;
        this.totalPage = data.total;
      },
      (e) => {
        this.items = []
        this.page = 1;
        this.collectionSize = 0;
        this.totalPage = 0;
      }
    );
  }
  filterChange() {
    this.page = 1;
    this.get();
  }
  openModal(md: any, size: string = 'md') {
    this.modal.open(md, {
      size: size,
    });
  }
  openEdit(id: number, md: any) {
    this.idSelected = id;
    this.modal.open(md, {
      size: 'md',
    });
  }
  openDelete(id: number, md: any) {
    this.form.get('id').setValue(id);
    this.modal.open(md, {
      size: 'md',
    });
  }
  search() {
    this.get();
  }
  clean() { }
}

